export default "__VITE_ASSET__d8dd0ae6__"